<template>
  <div style="width: 100%">
    <keep-alive>
      <BotonPanicoOferta v-if="menu.state == 'home'" />
      <BotonPanicoDetalle v-if="menu.state == 'detail'" />
    </keep-alive>
  </div>
</template>

<script>
import { default as BotonPanicoOferta } from "./Boton_Panico_Ofertas.vue";
import { default as BotonPanicoDetalle } from "./Boton_Panico_Detalle.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "botonPanico",
  components: {
    BotonPanicoOferta,
    BotonPanicoDetalle,
  },
  data: () => ({
    loading: false,
  }),
  mounted() {},
  computed: {
    ...mapGetters("horarios", ["menu"]),
  },
  methods: {},
};
</script>

<style scoped>
.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #a4a0a0 !important;
}
</style>
